/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Booking'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeBooking from '../../../components/booking/Home.vue'; // 'Home-Booking' ..
import Passengers from '../../../components/booking/passengers/Passengers.vue'; // 'Paxes&Service's ..
import Ownprices from '../../../components/booking/ownprices/Ownprices.vue'; // 'Ownprices' (Special 'DirectBooking' intermediary Step)
import Payment from '../../../components/booking/payment/Payment.vue'; // 'Payment' ..
import Overview from '../../../components/booking/overview/Overview.vue'; // 'Overview' ..
import Confirmation from '../../../components/booking/confirmation/Confirmation.vue'; // 'Confirmation' ..


export const routesbooking = [
    {
        path: '',
        component: HomeBooking
    },
    { path: '/passengers/:modulo?', name: 'Passengers', component: Passengers, props: true }, // Step: 2
    { path: '/ownprice/:modulo?', name: 'Ownprices', component: Ownprices, props: true }, // Step: 3, (Special 'DirectBooking' intermediary step)
    { path: '/payment/:modulo?', name: 'Payment', component: Payment, props: true }, // Step: 4
    { path: '/overview/:modulo?', name: 'Overview', component: Overview, props: true }, // Step: 5
    { path: '/confirmation/:modulo?', name: 'Confirmation', component: Confirmation, props: true }, // Step: 6
];
